/**
 * Copyright © 2020 Redbox Digital Limited. All rights reserved.
 */
define('js/mage/collapsible-mixin',[
    'jquery'
], function ($) {
    "use strict";
    return function (originalWidget) {
        $.widget('mage.collapsible', originalWidget, {
            _scrollToTopIfNotVisible: function () {
                if (this._isElementOutOfViewport()) {
                    $('html, body').animate({
                        scrollTop: $(this.header[0]).offset().top
                    }, 600);
                }
            }
        });
        return $.mage.collapsible;
    }
});

